var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "26", height: "26", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fill: "#fff", d: "M7.258 11.008l1.594-1.594 4.171 4.149 4.149-4.149 1.594 1.594-5.743 5.742z" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/carot.svg